const uppercase = function (value) {
  return value.toUpperCase()
}

export default uppercase
